import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useBreadcrumbs, useBreadcrumbItem } from 'react-aria';
import PropTypes from 'prop-types';
import Link from '../../links/Link';

/**
 * A component for displaying the navigation tree
 */
function Breadcrumbs(props) {
  const { homeHref, children } = props;
  const { t } = useTranslation();

  const { navProps } = useBreadcrumbs(props);

  return (
    <nav {...navProps} aria-label={t('styleguide:layout.header.breadcrumb')} className="breadcrumb">
      <span>{t('styleguide:you_are_here')}</span>
      <ol>
        <Crumb href={homeHref} text={t('styleguide:home')} />
        {children}
      </ol>
    </nav>
  );
}

export function Crumb(props) {
  const { href, text } = props;

  const ref = useRef(null);
  const { onClick: onPress, ...itemProps } = useBreadcrumbItem(props, ref);

  return (
    <li>
      <Link {...itemProps} href={href} ref={ref} isDisabled={itemProps['aria-disabled']}>
        {text}
      </Link>
    </li>
  );
}

Breadcrumbs.propTypes = {
  /**
   * The breadcrumbs
   */
  crumbs: PropTypes.arrayOf(PropTypes.object)
};

export default Breadcrumbs;
